<template>
  <div class="block-marks">
    <div
      v-for="(option, index) in options"
      :key="index"
      class="mark"
    >
      <v-btn
        :class="getClass(option.item)"
        icon
        :title="option.name"
        outlined
        small
        @click="saveMark(option)"
      >
        {{ option.item }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'marks-list-second',
  props: ['type', 'score', 'elemType'],
  data() {
    return {
      selected: {},
      options: [
        {item: '1', name: 'Неудовлетворительно'},
        {item: '2', name: 'Почти удовлетворительно'},
        {item: '3', name: 'Удовлетворительно'},
        {item: '4', name: 'Весьма удовлетворительно'},
        {item: '5', name: 'Хорошо'},
        {item: '6', name: 'Весьма хорошо'},
        {item: '7', name: 'Очень хорошо'},
        {item: '8', name: 'Почти отлично'},
        {item: '9', name: 'Отлично'},
        {item: '10', name: 'Превосходно'},
      ]
    }
  },

  mounted() {
    // console.log(this.elemType)
    // console.log(this.score)
  },

  methods: {
    saveMark(item) {
      this.selected = item
      this.$emit('selectMark', this.selected.item)
    },

    getClass(item) {
      if(Math.floor(this.score) == item) {
        return "custom-active-mark"
      }
    }
  }
}
</script>

<style>
  .mark .v-btn--icon.v-size--small {
    height: 25px;
    width: 25px;
  }
</style>
